<template>
    <div>
      <PageAppBar>{{title}}</PageAppBar>
      <div class="page-content header-clear-small">
        <div v-if="loading" class="text text-center">
          <mushonga></mushonga>
        </div>
        <div v-else>
          <div class="card card-style preload-img card-edit" data-src="images/pictures/27t.jpg" style="height: 250px; background-image: url(&quot;images/pictures/27t.jpg&quot;);">
            <div class="card-center text-center">
              <i class="fa fa-home fa-5x color-white"></i>
              <h1 class="color-white mt-4">{{ stand.project }}</h1>
              <p class="color-white font-12 mt-n2 mb-5 margin-edit">{{ stand.details }}</p>
            </div>
            <div class="card-overlay bg-black opacity-80"></div>
          </div>
          <div class="card card-style">
            <div class="content mb-2">
              <h3>Details</h3>
              <p>{{ message }}</p>
              <p>
                <span>
                  <i v-for="contribution in stand.my_contributions" :key="contribution.id" class="fa fa-star color-yellow1-dark"></i>
                </span>
              </p>
              <div class="divider mt-2 mb-2"></div>
              <div class="d-flex">
                <div class="pt-1">
                  <h5 data-activate="question-1" class="font-600">Contribution Amount: USD {{stand.contribution_amount}}</h5>
                </div>
              </div>
              <div class="divider mt-2 mb-2"></div>
              <div class="d-flex">
                <div class="pt-1">
                  <h5 data-activate="question-2" class="font-600">Number of installments: {{stand.number_of_contributions}}</h5>
                </div>
              </div>
              <div class="divider mt-2 mb-2"></div>
              <div class="d-flex">
                <div class="pt-1">
                  <h5 data-activate="question-3" class="font-600">Started: {{formatDate(stand.created_at)}}</h5>
                </div>
              </div>
<!--              <div v-show=" !(Object.keys(stand.my_contributions).length) " class="container">-->
<!--                <div class="col-md-12 text-center">-->
<!--                  <button @click="joinStandProject(stand)" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900">Join Project</button>-->
<!--                </div>-->
<!--              </div>-->
              <div v-if="!joined" class="container">
                <div class="col-md-12 text-center">
                  <button @click="joinStandProject(stand)" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900 color">Join Project</button>
                </div>
              </div>
              <div v-else-if="joined" class="container">
                <div class="col-md-12 text-center">
                  <router-link :to="'/chat/stands/'+stand.id" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900 color">Open Chat</router-link>
                </div>
              </div>
              <div v-else-if="loading" class="container">
                <mushonga></mushonga>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import axios from "axios";
import global from "@/mixins/global";
export default {
  mixins: [global],
  name: "SingleStand",
  components: {FooterBar, PageAppBar},
  mounted() {
    this.joined = false
    this.fetchStandProject();
  },
  data(){
    return {
      stand: {
        my_contributions: []
      },
      title: "Stand "+this.$route.params.id,
      loading: false
    }
  },
  methods: {
    fetchStandProject(){
      this.loading = true
      axios.get(this.base_url+"stands/"+this.$route.params.id, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
        this.stand = response.data.data
        if(Object.keys(this.stand.my_contributions).length){
          this.joined = true
        }
        this.title = this.stand.project
        this.loading = false
      }).catch(error=>{
        this.error = error
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@900&display=swap');
.color{

  border: 1px solid rgba(218, 68,83); 
  background-color:rgba(218, 68,83);
  border-radius: 10px;
  font-family: 'Roboto', sans-serif;
  
}
.card-edit{
  margin: 10px 7px 15px;
}
.margin-edit{
  margin-left: 8px;
  margin-right: 8px;
}


</style>